export const tableOptionsToFirstPage = (state ) =>{
    let tableOptions = JSON.parse(JSON.stringify(state.tableOptions));
    tableOptions.page = 1;
    return tableOptions;
};
